import styled from "styled-components";
import { Paragraph, Heading } from "../../../atoms/Typography/Typography.styles";

export const ModalPhoto = styled.div`
  width: 100%;
  position: relative;
  background-color: white;
  border-radius: ${({ theme }) => theme.rem(8)};
  padding: ${({ theme }) => theme.rem(32)};
  max-width: 45dvw;
  max-height: 95dvh;
  overflow-y: scroll;
`;

export const ModalPhotoIconWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  margin: ${({ theme }) => theme.rem(16)};
  cursor: pointer;

  i {
    font-size: ${({ theme }) => theme.rem(24)};
  }
`

export const ModalPhotoContent = styled.div`
  padding: ${({ theme }) => theme.rem(32)};

  ${Paragraph},
  ${Heading} {
    color: black;
  }
`

export const ModalPhotoImageWrapper = styled.div<{ aspectRatio: string }>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  border-radius: ${({ theme }) => theme.rem(8)};
  overflow: hidden;

  img {
    object-fit: contain;
    object-position: center;
  }
`